import {
  AfterViewInit,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import {DataPoint} from "../chart/chart.component";

export class MetricSettings {
  constructor(
  public title: string,
  public icon: string,
  public description: string,
  public interaction: string,
  public key: string,
  public rgb: number[],
  public data: DataPoint[],
  public ordinalOptions: { current: string, previous: string, relativeTime: boolean } = { current: 'today', previous: 'yesterday', relativeTime: true }) {}
}

@Component({
  selector: 'pla-metric-graph-collection',
  templateUrl: './metric-graph-collection.component.html',
})
export class MetricGraphCollectionComponent implements OnInit, AfterViewInit {
  @Input() public metrics: MetricSettings[];
  @Input() public description: string;

  constructor() {}

  ngOnInit(): void {}

  ngAfterViewInit(): void {}
}
